module.exports = __webpack_public_path__ + "static/media/checkoutSuccessBg.2afdf940.png";